import { render, staticRenderFns } from "./UploadReferencesModal.vue?vue&type=template&id=80abd29a&scoped=true&"
import script from "./UploadReferencesModal.vue?vue&type=script&lang=js&"
export * from "./UploadReferencesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadReferencesModal.vue?vue&type=style&index=0&id=80abd29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80abd29a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VExpansionPanels,VIcon,VSpacer})
